module.exports = __webpack_public_path__ + "static/media/WhatsApp_Logo_8.f3de4430.png";